const GOOGLE_AD_SESSION_KEY = 'is_google_ad';
const GOOGLE_AD_CLICK_ID_PARAMS = ['gclid', 'gbraid', 'wbraid'];

const hasGoogleAdClickId = (value) => {
  if (!value) return false;

  try {
    const url = new URL(value, window.location.origin);
    return GOOGLE_AD_CLICK_ID_PARAMS.some((param) => url.searchParams.has(param));
  } catch (e) {
    return GOOGLE_AD_CLICK_ID_PARAMS.some((param) => new RegExp(`[?&]${param}=`, 'i').test(value));
  }
};

const hasGoogleAdCookie = () => {
  if (typeof document === 'undefined') return false;

  return /(?:^|;\s*)(gclid|_gcl_aw|is_google_ad)=/i.test(document.cookie || '');
};

const hasGoogleAdLocalStorage = () => {
  if (typeof localStorage === 'undefined') return false;

  try {
    if (localStorage.getItem(GOOGLE_AD_SESSION_KEY) === 'true') return true;

    const localStorageValues = Object.keys(localStorage).map((key) => localStorage.getItem(key) || '');

    return GOOGLE_AD_CLICK_ID_PARAMS.some((param) => (
      localStorage.getItem(param)
      || (localStorage.getItem('_gcl_ls') || '').includes(`"${param}"`)
      || localStorageValues.some((value) => hasGoogleAdClickId(value))
    ));
  } catch (e) {
    return false;
  }
};

export const markGoogleAdSession = () => {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(GOOGLE_AD_SESSION_KEY, 'true');
    }

    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(GOOGLE_AD_SESSION_KEY, 'true');
    }

    if (typeof document !== 'undefined') {
      document.cookie = `${GOOGLE_AD_SESSION_KEY}=true; path=/; max-age=2592000; SameSite=Lax`;
    }
  } catch (e) {
    return false;
  }

  return true;
};

export const isGoogleAdSession = () => {
  if (typeof window === 'undefined') return false;

  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(GOOGLE_AD_SESSION_KEY) === 'true') return true;
    if (hasGoogleAdCookie() || hasGoogleAdLocalStorage()) {
      markGoogleAdSession();
      return true;
    }

    const urls = [
      window.location.href,
      document.referrer,
      typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('referrer_url') : null
    ];

    if (urls.some(hasGoogleAdClickId)) {
      markGoogleAdSession();
      return true;
    }
  } catch (e) {
    return false;
  }

  return false;
};
